import React from 'react';
import Img from 'gatsby-image';
import { Container, Paper } from 'library';

import './EmployeeQuotes.scss';

const EmployeeQuotes = ({ quotes }) => {
  return (
    <Container className="EmployeeQuotesContainer" row justify="center">
      <Container grid="10">
        <Paper theme="medium" className="EmployeeQuotes">
          {quotes.map(({ quote: [{ text, attribution }], image }) => {
            return (
              <div className="EmployeeQuotesQuote" key={attribution.name}>
                {image?.sourceUrl && (
                  <figure className="EmployeeQuotesImage">
                    <Img
                      fixed={image.localFile.childImageSharp.fixed}
                      alt={image.altText || `${attribution.name} enjoying time with their family`}
                    />
                  </figure>
                )}
                <article className="EmployeeQuotesTextContainer">
                  <div className="EmployeeQuotesTextAttribution">
                    <p>{attribution.name}</p>
                    <p>{attribution.title}</p>
                  </div>
                  <p className="EmployeeQuotesText">{text}</p>
                </article>
              </div>
            );
          })}
        </Paper>
      </Container>
    </Container>
  );
};

export default EmployeeQuotes;
